export const CANDIDATE = {
  msisCard: 'candidate-choice-msis-card',
  msosCard: 'candidate-choice-msos-card',
  adminLink: 'candidate-admin-link',
  testIdInput: 'test-id-input',
  validateButton: 'test-id-validate-button',
  sendCodeButton: 'send-code-button',
  codeInput: 'verification-code-input',
  verifyButton: 'verify-code-button',
  backButton: 'candidate-back-button',
  errorMessage: 'candidate-error-message',
};

export const DOMAINS = {
  countOption: 'domain-count-option',
  domainCard: 'domain-select-card',
  continueButton: 'domain-selection-continue-button',
};

export const RUNNER = {
  question: 'test-question-stem',
  option: 'test-option',
  nextButton: 'test-next-button',
  prevButton: 'test-prev-button',
  submitButton: 'test-submit-button',
  progress: 'test-progress',
};

export const REPORT = {
  container: 'report-container',
  recommended: 'report-recommended-specialization',
  overall: 'report-overall-score',
  downloadPdf: 'report-download-pdf-button',
  domainRow: 'report-domain-row',
};
